<template>
    <div class="form_wrap">
        <div class="form_box">
            <div class="form_inner">
                <a class="logo" href="/"><img src="@/assets/logo.svg" alt="Logo"></a>
                <div class="inp_flx mb10">
                    <div class="inp">
                        <input type="text" name="username" id="username" v-model="username" placeholder="아이디를 입력해주세요">
                    </div>
                    <div class="inp">
                        <input type="password" name="user_pw" id="user_pw" v-model="user_pw" placeholder="비밀번호를 입력해주세요">
                    </div>
                </div>
                
                <!--a href="/">비밀번호를 잃어버리셨나요?</a-->
                <!--span class="chk_inp">
                    <input type="checkbox" id="chk" name="checkbox">
                    <label for="chk">자동로그인</label>
                </span-->
                <div class="inp_flx">
                    <div class="inp_btn">
                        <input type="submit" value="로그인" @click="loginUser">
                    </div>
                    <div class="join">
                        <a href="/register_form">아직 회원이 아니신가요? <span>회원가입</span></a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "@/api"; // axios instance

    export default {
        name: 'LoginForm',
	data() {
            return {
                username: "",
                user_pw: ""
            };
        },
        methods: {
            goRegister() {
                window.location.href = '/register_form';
            },

            async loginUser() {
                if (!this.username.trim()) {
                    alert("아이디를 입력해주세요.");
                    return;
                }
                if (!this.user_pw.trim()) {
                    alert("비밀번호를 입력해주세요.");
                    return;
                }

                try {
                    // CSRF 쿠키 생성
                    await api.get('/sanctum/csrf-cookie', { withCredentials: true });

                    const response = await api.post(
                        "/admin/userlogin",
                        { username: this.username, user_pw: this.user_pw },
                        { withCredentials: true }
                    );

                    const result = response.data;

                    if (result.success) {
                        alert("정상적으로 로그인되었습니다.");
                        window.location.href = "/";
                    } else {
                        alert(result.message || "로그인 실패");
                    }

                } catch (error) {
                    console.error(error);
                    alert("서버 오류가 발생했습니다.");
                }
            }
        }
    }
</script>